import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../../general/base/base.component';
import { NotificationService } from '../../notification.service';
import { StateService } from '../../../../shared/state/state.service';
import { AuthService } from '../../../../auth/auth.service';
import { NotificationEntry } from '../../notification.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'qm-whiteboard',
  templateUrl: './whiteboard.component.html',
  styleUrls: ['./whiteboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhiteboardComponent extends BaseComponent implements OnInit {
  /**
   * Map of search result lists, Map is used so that results can be grouped in future.
   */
  public results: Map<string, any>;
  /**
   * Notification
   */
  public notification: NotificationEntry;

  /**
   *
   * @param {NotificationService} notificationService
   * @param {StateService} stateService
   * @param {AuthService} auth
   */
  constructor(private notificationService: NotificationService,
              private modalService: NgbModal,
              private auth: AuthService) {
    super();
    this.name = 'WhiteboardComponent';
  }

  ngOnInit() {
    this.notification = new NotificationEntry();
  }

  public async save() {
    this.notification.userId = this.auth.getSubject();
    await this.notificationService.create(this.notification);
    this.modalService.dismissAll();
  }

  public close() {
    this.modalService.dismissAll();
  }

  flagNotification(n: any) {
    console.log('asdasdasd', n);
  }
}
